import * as type from "../types/campaigns";

export const retrieveCampaignsChannels = (payload) => {
  return {
    type: type.REQUEST_CAMPAIGNS_CHANNELS,
    payload: payload,
  };
};

export const resetCampaignsChannels = () => {
  return {
    type: type.RESET_CAMPAIGNS_CHANNELS,
  };
};

export const setActiveChannelDisplay = (payload) => {
  return {
    type: type.SET_ACTIVE_CHANNEL_DISPLAY,
    details: payload,
  };
};

export const resetActiveChannelDisplay = () => {
  return {
    type: type.RESET_ACTIVE_CHANNEL_DISPLAY,
  };
};

export const requestActiveChannelCredits = (payload) => {
  return {
    type: type.REQUEST_SET_ACTIVE_CHANNEL_CREDITS,
    details: payload,
  };
};

export const resetActiveChannelCredits = () => {
  return {
    type: type.RESET_SET_ACTIVE_CHANNEL_CREDITS,
  };
};

export const requestActiveEmailChannelStatistics = (payload) => {
  return {
    type: type.REQUEST_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS,
    details: payload,
  };
};

export const resetActiveEmailChannelStatistics = () => {
  return {
    type: type.RESET_SET_ACTIVE_EMAIL_CHANNEL_STATISTICS,
  };
};

export const requestActiveEmailChannelReputation = (payload) => {
  return {
    type: type.REQUEST_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION,
    details: payload,
  };
};

export const resetActiveEmailChannelReputation = () => {
  return {
    type: type.RESET_SET_ACTIVE_EMAIL_CHANNEL_REPUTATION,
  };
};

export const requestActiveChannelSource = (payload) => {
  return {
    type: type.REQUEST_SET_ACTIVE_CHANNEL_SOURCE,
    details: payload,
  };
};

export const resetActiveChannelSource = () => {
  return {
    type: type.RESET_SET_ACTIVE_CHANNEL_SOURCE,
  };
};

export const retrieveChannelEmails = (payload) => {
  return {
    type: type.REQUEST_CHANNEL_EMAILS_CONTENT,
    payload: payload,
  };
};

export const resetChannelEmails = () => {
  return {
    type: type.RESET_CHANNEL_EMAILS_CONTENT,
  };
};

export const retrieveChannelSms = (payload) => {
  return {
    type: type.REQUEST_CHANNEL_SMS_CONTENT,
    payload: payload,
  };
};

export const resetChannelSms = () => {
  return {
    type: type.RESET_CHANNEL_SMS_CONTENT,
  };
};

export const appendDeletionArray = (payload) => {
  return {
    type: type.APPEND_CAMPAIGNS_DELETION_ARRAY,
    id: payload,
  };
};

export const subtractDeletionArray = (payload) => {
  return {
    type: type.SUBTRACT_CAMPAIGNS_DELETION_ARRAY,
    id: payload,
  };
};

export const changeCampaignsModal = (payload) => {
  return {
    type: type.CHANGE_CAMPAIGNS_MODALS,
    modal: payload,
  };
};

export const setActiveEmailChannelStatisticsDate = (payload) => {
  return {
    type: type.SET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE,
    details: payload,
  };
};

export const resetActiveEmailChannelStatisticsDate = () => {
  return {
    type: type.RESET_ACTIVE_EMAIL_CHANNEL_STATISTICS_DATE,
  };
};

export const requestDistributionSelections = (payload) => {
  return {
    type: type.REQUEST_DISTRIBUTION_SELECTIONS,
    payload: payload,
  };
};

export const resetDistributionSelections = () => {
  return {
    type: type.RESET_DISTRIBUTION_SELECTIONS,
  };
};

export const requestSendBulkEmails = (payload) => {
  return {
    type: type.REQUEST_SEND_BULK_EMAILS,
    payload: payload,
  };
};

export const resetSendBulkEmails = () => {
  return {
    type: type.RESET_SEND_BULK_EMAILS,
  };
};

export const requestSendBulkSms = (payload) => {
  return {
    type: type.REQUEST_SEND_BULK_SMS,
    payload: payload,
  };
};

export const resetSendBulkSms = () => {
  return {
    type: type.RESET_SEND_BULK_SMS,
  };
};

export const requestDomainAuthentication = (payload) => {
  return {
    type: type.REQUEST_DOMAIN_AUTHENTICATION,
    payload: payload,
  };
};

export const resetDomainAuthentication = () => {
  return {
    type: type.RESET_DOMAIN_AUTHENTICATION,
  };
};

export const requestDomainVerification = (payload) => {
  return {
    type: type.REQUEST_DOMAIN_VERIFICATION,
    payload: payload,
  };
};

export const resetDomainVerification = () => {
  return {
    type: type.RESET_DOMAIN_VERIFICATION,
  };
};

export const requestDeleteEmailChannelDomain = (payload) => {
  return {
    type: type.REQUEST_DELETE_EMAIL_CHANNEL_DOMAIN,
    payload: payload,
  };
};

export const resetDeleteEmailChannelDomain = () => {
  return {
    type: type.RESET_DELETE_EMAIL_CHANNEL_DOMAIN,
  };
};

export const requestDomainDnsConfig = (payload) => {
  return {
    type: type.REQUEST_DOMAIN_DNS_CONFIG,
    payload: payload,
  };
};

export const resetDomainDnsConfig = () => {
  return {
    type: type.RESET_DOMAIN_DNS_CONFIG,
  };
};

export const setViewEmailDisplay = (payload) => {
  return {
    type: type.SET_SENT_EMAIL_DISPLAY,
    details: payload,
  };
};

export const resetViewEmailDisplay = () => {
  return {
    type: type.RESET_SENT_EMAIL_DISPLAY,
  };
};

export const requestChangeMailPlan = (payload) => {
  return {
    type: type.REQUEST_MAIL_PLAN_CHANGE,
    payload: payload,
  };
};

export const resetChangeMailPlan = () => {
  return {
    type: type.RESET_MAIL_PLAN_CHANGE,
  };
};

export const requestPurchaseNumber = (payload) => {
  return {
    type: type.REQUEST_PURCHASE_NUMBER,
    payload: payload,
  };
};

export const resetPurchaseNumber = () => {
  return {
    type: type.RESET_PURCHASE_NUMBER,
  };
};

export const requestAddEmailChannel = (payload) => {
  return {
    type: type.REQUEST_ADD_EMAIL_CHANNEL,
    payload: payload,
  };
};

export const resetAddEmailChannel = () => {
  return {
    type: type.RESET_ADD_EMAIL_CHANNEL,
  };
};

export const requestAddSmsChannel = (payload) => {
  return {
    type: type.REQUEST_ADD_SMS_CHANNEL,
    payload: payload,
  };
};

export const resetAddSmsChannel = () => {
  return {
    type: type.RESET_ADD_SMS_CHANNEL,
  };
};

export const requestDeleteEmailChannel = (payload) => {
  return {
    type: type.REQUEST_DELETE_EMAIL_CHANNEL,
    payload: payload,
  };
};

export const resetDeleteEmailChannel = () => {
  return {
    type: type.RESET_DELETE_EMAIL_CHANNEL,
  };
};

export const requestNumbersAvailable = (payload) => {
  return {
    type: type.REQUEST_NUMBERS_AVAILABLE,
    payload: payload,
  };
};

export const resetNumbersAvailable = () => {
  return {
    type: type.RESET_NUMBERS_AVAILABLE,
  };
};

export const requestDeleteSmsChannelNumber = (payload) => {
  return {
    type: type.REQUEST_DELETE_SMS_CHANNEL_NUMBER,
    payload: payload,
  };
};

export const resetDeleteSmsChannelNumber = () => {
  return {
    type: type.RESET_DELETE_SMS_CHANNEL_NUMBER,
  };
};

export const requestChangeSmsPlan = (payload) => {
  return {
    type: type.REQUEST_SMS_PLAN_CHANGE,
    payload: payload,
  };
};

export const resetChangeSmsPlan = () => {
  return {
    type: type.RESET_SMS_PLAN_CHANGE,
  };
};
